export default __webpack_public_path__ + "static/w-1-mobile-c8b8e2166d48c610096517e3cbe65b60.webp";